export const allTags = ['all', 'events', 'updates', 'news']
